export const CustomersActionTypes = {
    GET_CUSTOMERS_REQUEST: "GET_CUSTOMERS_REQUEST",
    GET_CUSTOMERS_SUCCESS: "GET_CUSTOMERS_SUCCESS",
    GET_CUSTOMERS_FAILURE: "GET_CUSTOMERS_FAILURE",
    GET_CUSTOMER_BY_ID_REQUEST: "GET_CUSTOMER_BY_ID_REQUEST",
    GET_CUSTOMER_BY_ID_SUCCESS: "GET_CUSTOMER_ID_SUCCESS",
    GET_CCUSTOMER_BY_ID_FAILURE: "GET_CCUSTOMER_BY_ID_FAILURE",
};
